import { useState } from "react";

import { useMutation, useQuery } from "@tanstack/react-query";

import { useAppState } from "../../../../../../../../context/StateContext";
import { Carrier } from "../../../../../../../../models/carrier";
import { Filters, Searches, Sort, Sorts } from "../../../../../../../../models/shipeezi.table";
import CarrierService from "../../../../../../../../services/carrier.service";

export const useActions = () => {
  const { currentUser } = useAppState();

  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(15);
  const [filters, setFilters] = useState<Filters>();
  const [searches, setSearches] = useState<Searches>();
  const [sorting, setSorting] = useState<Sorts>();

  const setCurrentPage = (numberPage: number) => setPage(numberPage - 1);

  const handleSearch = (value: Searches) => {
    setSearches(value);
    setPage(0);
  };

  const handleFilter = (value: Filters) => {
    setFilters(value);
    setPage(0);
  };

  const handleSort = (sorts: Sort[]) => {
    const sorting: Sorts = [];

    sorts.forEach((sort) => sorting.push([sort.columnName, sort.direction]));
    setSorting(sorting);
  };

  const {
    refetch: getAllCarrier,
    isFetching: isFetchingAllCarrier,
    data: carriersResponse,
  } = useQuery(
    ["get.all.carrier", page, pageSize, filters, searches, sorting],
    () =>
      CarrierService.getAll({
        page,
        pageSize,
        companyId: currentUser?.companyId,
        searchByOr: searches && searches.length ? JSON.stringify(searches) : "",
        sortBy: sorting ? JSON.stringify(sorting) : "",
        include: JSON.stringify([{ association: "trackableBy" }]),
        ...filters,
      }),
    {
      refetchOnWindowFocus: false,
    }
  );

  const {
    refetch: countTotalCarrier,
    isFetching: isFetchingTotalCarrier,
    data: carrierTotalResponse,
  } = useQuery(
    ["get.total.carrier", filters, searches],
    () =>
      CarrierService.count({
        companyId: currentUser?.companyId,
        searchByOr: searches && searches.length ? JSON.stringify(searches) : "",
        ...filters,
      }),
    {
      refetchOnWindowFocus: false,
    }
  );

  type UpdateProps = {
    id: number;
    carrier: Carrier;
  };
  const create = () =>
    useMutation(["create.carrier"], (carrier: Carrier) => CarrierService.create(carrier));

  const update = () =>
    useMutation(["update.carrier"], ({ id, carrier }: UpdateProps) =>
      CarrierService.update(id, carrier)
    );

  return {
    carriers: carriersResponse?.data,
    totalCarrier: carrierTotalResponse?.data,
    isFetching: isFetchingTotalCarrier || isFetchingAllCarrier,
    page,
    setPage,
    pageSize,
    setPageSize,
    setCurrentPage,
    handleSearch,
    handleFilter,
    handleSort,
    getAllCarrier,
    countTotalCarrier,
    create,
    update,
  };
};
